export default __webpack_public_path__ + "static/media/IMG_20170818_173814.b8e03cd1.jpg";